import { h } from 'preact'
import PropTypes from 'prop-types'

const Link = (props, context) => {
  const other = { ...props }
  delete other.localhref
  return (
    <a
      {...other} // pass other properties
      href={(() => {
        if (props.directhref) return props.directhref
        if (!context.hostname) return props.href
        if (/:\/\//.exec(props.href)) return props.href
        if (props.localhref) return context.hostname + props.localhref
        return `${context.hostname}/${props.href}`
      })()}
    >
      {props.children}
    </a>
  )
}

Link.contextTypes = {
  hostname: PropTypes.string,
}

export default Link



// WEBPACK FOOTER //
// ./components/visual/Link.js